type Props = {
  /**
   * A string representing the ID of the placeholder.
   */
  placeholderId: string;
};

export const ContentPlaceholderUI = ({ placeholderId }: Props) => (
  <div
    data-testid={`test-${placeholderId}`}
    id={placeholderId}
    data-component="ContentPlaceholder"
  ></div>
);
